export function getLocalISOString(date: Date): string {
  // Get the timezone offset in minutes
  const tzOffsetMinutes = date.getTimezoneOffset();

  // Convert the offset to hours and minutes
  const tzOffsetHours = Math.floor(Math.abs(tzOffsetMinutes) / 60);
  const tzOffsetMins = Math.abs(tzOffsetMinutes) % 60;

  // Determine the sign (+ or -)
  const tzSign = tzOffsetMinutes > 0 ? "-" : "+";

  // Create the local ISO string (remove "Z" from default toISOString())
  const localISO = new Date(date.getTime() - tzOffsetMinutes * 60000)
    .toISOString()
    .replace("Z", ""); // Remove default 'Z' (UTC indicator)

  // Append the timezone offset
  return `${localISO}${tzSign}${tzOffsetHours.toString().padStart(2, '0')}:${tzOffsetMins.toString().padStart(2, '0')}`;
}
